import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export type OtpTestPhoneRecord = {
  id: string;
  phoneNumber: string;
  description?: string | null;
  clientEnabled: boolean;
  clientOtpCode?: string | null;
  driverEnabled: boolean;
  driverOtpCode?: string | null;
  expiresAt?: string | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};

export type OtpTestPhonePayload = {
  phoneNumber: string;
  description?: string | null;
  clientEnabled: boolean;
  clientOtpCode?: string | null;
  driverEnabled: boolean;
  driverOtpCode?: string | null;
  expiresAt?: string | null;
};

function normalizePayload(payload: OtpTestPhonePayload) {
  return {
    phoneNumber: payload.phoneNumber.trim(),
    description: payload.description?.trim() || null,
    clientEnabled: payload.clientEnabled === true,
    clientOtpCode: payload.clientOtpCode?.trim() || null,
    driverEnabled: payload.driverEnabled === true,
    driverOtpCode: payload.driverOtpCode?.trim() || null,
    expiresAt: payload.expiresAt?.trim() || null,
  };
}

export const otpTestPhoneService = {
  async list(): Promise<OtpTestPhoneRecord[]> {
    const callable = httpsCallable(functions, 'listOtpTestPhones');
    const res = await callable({});
    const data = (res.data as { phones?: OtpTestPhoneRecord[] } | undefined) || {};
    return Array.isArray(data.phones) ? data.phones : [];
  },

  async create(payload: OtpTestPhonePayload): Promise<OtpTestPhoneRecord> {
    const callable = httpsCallable(functions, 'createOtpTestPhone');
    const res = await callable(normalizePayload(payload));
    const data = (res.data as { success?: boolean; phone?: OtpTestPhoneRecord } | undefined) || {};
    if (!data.success || !data.phone) {
      throw new Error('Echec createOtpTestPhone');
    }
    return data.phone;
  },

  async update(payload: OtpTestPhonePayload): Promise<OtpTestPhoneRecord> {
    const callable = httpsCallable(functions, 'updateOtpTestPhone');
    const res = await callable(normalizePayload(payload));
    const data = (res.data as { success?: boolean; phone?: OtpTestPhoneRecord } | undefined) || {};
    if (!data.success || !data.phone) {
      throw new Error('Echec updateOtpTestPhone');
    }
    return data.phone;
  },

  async remove(phoneNumber: string): Promise<void> {
    const callable = httpsCallable(functions, 'deleteOtpTestPhone');
    const res = await callable({ phoneNumber: phoneNumber.trim() });
    const data = (res.data as { success?: boolean } | undefined) || {};
    if (!data.success) {
      throw new Error('Echec deleteOtpTestPhone');
    }
  },
};

export default otpTestPhoneService;
